
import { createContext, useEffect, useReducer } from 'react';



import PropTypes from 'prop-types';
// utils
import axios from '../utils/axios';
import { setSession } from '../utils/jwt';








// ----------------------------------------------------------------------

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
  setting: null,
};
const handlers = {
  INITIALIZE: (state, action) => {
    const { isAuthenticated, user } = action.payload;
    return {
      ...state,
      isAuthenticated,
      isInitialized: true,
      user,
    };
  },
  SETTING: (state, action) => {
    const { setting } = action.payload;
    return {
      ...state,
      setting
    };
  },
  LOGIN: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
  LOGOUT: (state) => ({
    ...state,
    isAuthenticated: false,
    user: null,
  }),
  REGISTER: (state, action) => {
    const { user } = action.payload;

    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
  VERIFY: (state, action) => {
    const { user } = action.payload;
    return {
      ...state,
      isAuthenticated: 'verify',
      user,
    };
  },
  CHECK: (state, action) => {
    const { user } = action.payload;
    return {
      ...state,
      isAuthenticated: true,
      user,
    };
  },
  UPDATE_PROFILE: (state, action) => {
    const { user } = action.payload;
    return {
      ...state,
      user,
    };
  },
};

const reducer = (state, action) => (handlers[action.type] ? handlers[action.type](state, action) : state);

const AuthContext = createContext({
  ...initialState,
  method: 'jwt',
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  register: () => Promise.resolve(),
  verify: () => Promise.resolve(),
  updateProfile: () => Promise.resolve(),
  fetchSetting: () => Promise.resolve(),
});

// ----------------------------------------------------------------------

AuthProvider.propTypes = {
  children: PropTypes.node,
};

function AuthProvider({ children }) {

  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem('accessToken');
        if (accessToken !== 'undefined' && accessToken !== null && accessToken !== '') {
          console.log('[Auth] Initializing with token:', accessToken.substring(0, 10) + '...');
          setSession(accessToken);
          const response = await axios.get(`/api/account/my-account/${accessToken}`, {
          });
          const userData = response.data.user

          console.log('[Auth] User Session Rehydrated:', userData?.username, 'Status:', response.data.status);
          if (response.data.status === 'success') {
            dispatch({
              type: 'INITIALIZE',
              payload: {
                isAuthenticated: true,
                user: userData,
              },
            });
          } else if (response.data.status === 'verify') {
            dispatch({
              type: 'INITIALIZE',
              payload: {
                isAuthenticated: 'verify',
                user: userData,
              },
            });
          } else {
            console.warn('[Auth] Session validation failed', response.data);
            dispatch({
              type: 'INITIALIZE',
              payload: {
                isAuthenticated: false,
                user: null,
              },
            });
          }

        } else {
          dispatch({
            type: 'INITIALIZE',
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
        console.error('[Auth] Initialization Error:', err);
        // Clear invalid token
        localStorage.removeItem('accessToken');
        dispatch({
          type: 'INITIALIZE',
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
      
      // Fetch settings separately (don't block auth initialization)
      try {
        const res = await axios.get(`/api/website/app/setting`);
        console.log('[Auth] System Settings Loaded');
        dispatch({
          type: 'SETTING',
          payload: {
            setting: res.data,
          },
        });
      } catch (settingsErr) {
        console.error('[Auth] Settings Load Error:', settingsErr);
        // Don't block app if settings fail
      }
    };

    initialize();
  }, []);

  const login = async (username, password) => {
    console.log('[Auth] Attempting Login for:', username);
    try {
      const response = await axios.post('/api/login/verify/user', {
        username,
        password,
      });

      console.log('[Auth] Login Response Received:', response.data);

      if (response.data.status === 'verify') {
        const accessToken = response.data.token;
        setSession(accessToken);
        dispatch({
          type: 'VERIFY',
          payload: {
            user: response.data.user,
          },
        });
        return response.data;
      } 
      
      if (response.data.status === 'success') {
        const accessToken = response.data.token;
        const userData = response.data.user;
        
        console.log('[Auth] Login Success! Setting session and dispatching...');
        setSession(accessToken);
        
        dispatch({
          type: 'LOGIN',
          payload: {
            user: userData,
          },
        });
        
        return response.data;
      }
      
      // Handle unexpected status
      console.error('[Auth] Login failed with status:', response.data.status, response.data.message);
      throw new Error(response.data.message || 'Login failed');
      
    } catch (error) {
      console.error('[Auth] Login Exception:', error);
      // If error.message contains HTML tags, it might be a PHP error
      if (typeof error.message === 'string' && error.message.includes('<b>Deprecated</b>')) {
        throw new Error('Server returned a deprecation warning. Please check backend logs.');
      }
      throw error;
    }
  };

  const register = async (email, password, name, username, phone, ref, pin) => {
    const response = await axios.post('/api/register', {
      email,
      password,
      name,
      username,
      phone,
      ref,
      pin
    }, {
    });
    const accessToken = response.data.token;
    const userData = response.data.user
    setSession(accessToken);
    if (response.data.status === 'verify') {
      dispatch({
        type: 'VERIFY',
        payload: {
          user: userData,
        },
      });
    } else {
      dispatch({
        type: 'REGISTER',
        payload: {
          user: userData,
        },
      });
    }
  };

  const verify = async (code, email) => {
    const res = await axios.post('/api/verify/user/account', {
      code,
      email
    }, {
    });

    dispatch({
      type: 'CHECK',
      payload: {
        user: res.data.user,
      },
    });
  };

  const fetchSetting = async () => {
    try {
      const res = await axios.get(`/api/website/app/setting`);
      console.log('[Auth] Settings Refreshed');
      dispatch({
        type: 'SETTING',
        payload: {
          setting: res.data,
        },
      });
      return res.data;
    } catch (error) {
      console.error('[Auth] Settings Refresh Error:', error);
      throw error;
    }
  };

  const logout = async () => {
    setSession(null);
    window.localStorage.clear('userKey');
    window.localStorage.clear();
    window.localStorage.clear('accessToken');
    dispatch({ type: 'LOGOUT' });
  };

  const updateProfile = (user) => {
    dispatch({
      type: 'UPDATE_PROFILE',
      payload: {
        user,
      },
    });
  };

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'post',
        login,
        logout,
        register,
        verify,
        updateProfile,
        fetchSetting
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
